<article>
    <div>
        <h1>Admin Code가 변경되었습니다.<br> 해당 화면에서 로그아웃됩니다.<br> 변경한 Admin Code로 로그인해주세요.</h1>
    </div>
</article>